<template>
    <div :class="`download-option-wrapper ${$slots.input ? 'with-input' : ''}`">
        <div class="checkbox-container">
            <slot />
            <p v-if="tooltip">{{ tooltip }}</p>
        </div>

        <div v-if="$slots.input" class="input-container">
            <slot name="input" />
        </div>
    </div>
</template>

<script lang="ts" setup>
const { tooltip } = defineProps<{
    tooltip?: string;
}>();
</script>

<style lang="scss">
.download-option-wrapper {
    display: flex;
    gap: 10px;
    &.with-input {
        display: grid;
        grid-template-columns: 1fr 200px;
        gap: 15px;
    }

    .checkbox-container {
        flex: 1;
        display: flex;
        flex-direction: column;

        .ivu-checkbox-wrapper {
            display: flex;
            align-items: center;
            width: max-content;
        }
    }

    p {
        padding-left: 20px;
        font-size: 12px;
    }

    .ivu-input-group-with-append {
        input {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }

        .ivu-input-group-append {
            border-top-right-radius: var(--wpp-border-radius-m);
            border-bottom-right-radius: var(--wpp-border-radius-m);
            border-color: var(--wpp-grey-color-600);
        }
    }

    .input-container {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        input {
            width: 100%;
        }
    }

    .small-input {
        width: 60px;
    }
}
</style>
